import { render, staticRenderFns } from "./ProductExaDeta.vue?vue&type=template&id=46a27e12&scoped=true"
import script from "./ProductExaDeta.vue?vue&type=script&lang=js"
export * from "./ProductExaDeta.vue?vue&type=script&lang=js"
import style0 from "./ProductExaDeta.vue?vue&type=style&index=0&id=46a27e12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a27e12",
  null
  
)

export default component.exports